import React from "react";
import { Form, Modal, Button, Spin, Icon, Row, Col, Select, Input, InputNumber } from 'antd';

import CatalogosRequest from '../../services/Catalogos';
import { openNotification } from '../../util/notificaciones';
import ArticulosRequest from '../../services/Articulos';
import ArticulosMultiplosRequest from '../../services/ArticulosMultiplos';
import BaseComponent from "../Common/BaseComponent";

const { Option } = Select;
const { Search } = Input;
const { confirm } = Modal;

class FormAsignarUnidad extends BaseComponent {
    state = {
        arrPlazas: [],
        arrDrives: [],
        arrArticulos: [],
        guardando: false,
        cargandoDrive: false,
        cargandoArticulos: false,
        bloquearBotones: false,
    }

    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        
        if(this.props.modo === 'nuevo')
        {
            if(!state.arrPlazas.length)
            {
                CatalogosRequest.ListarPlazas()
                    .then(plazaResp => {
                        state.arrPlazas = plazaResp.data;
                        
                        this.setState(state);
                    })
                    .catch(err => {
                        this.setState({ cargando: false });
                        openNotification(
                            "Ha ocurrido un error.",
                            "Error",
                            false
                        )
                    });  
            }
        }
        else {
            if(this.props.asignarUDM_selected !== prevProps.asignarUDM_selected)
            {
                if (this.props.asignarUDM_selected !== null)
                {
                    if(!state.arrPlazas.length)
                    {
                        CatalogosRequest.ListarPlazas()
                            .then(plazaResp => {
                                state.arrPlazas = plazaResp.data;
                                this.setState(state);
                            })
                            .catch(err => {
                                this.setState({ cargando: false });
                                openNotification(
                                    "Ha ocurrido un error.",
                                    "Error",
                                    false
                                )
                            });  

                        this.state.arrArticulos.push(this.props.asignarUDM_selected.articulo);
                        this.onChangePlaza(this.props.asignarUDM_selected.sitio.plaza)
                    }
                }
            }
        }
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    onChangePlaza = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null
        if (value !== undefined) {
            state.cargandoDrive = true;
            state.plazaSelected = value
            CatalogosRequest.ListarSitios(value).then(response => {
                state.arrDrives = response.data
                state.cargandoDrive = false;
                this.setState(state)
            }).catch(err => {
                state.cargandoDrive = false;
                openNotification(
                    "Ha ocurrido un error al cargar los drives de la plaza.",
                    "Error al cargar drives",
                    false
                )
            });
        }

        this.setState(state)
    }

    /**
     * Función para buscar un artículo
     * @param: value. se manda el codigo del material o la descripción
     * @return: regresa el listado de artículos encontrados.
     */
    buscarArticulo = (value) => {
        let state = { ...this.state }
        let filtros = {}
        if (value.trim()) {
            filtros.filtro = value
            const { setFieldsValue } = this.props.form
            setFieldsValue({
                articulo: null
            })
            this.setState({ cargandoArticulos: true }, () => {
                ArticulosRequest.ListarArticulos(filtros)
                    .then(response => {
                        state.arrArticulos = response.data.results
                        state.cargandoArticulos = false;
                        this.setState(state)
                        if (!response.data.results.length) openNotification(
                            "No se ha encontrado un artículo con el código / descripción ingresado.",
                            "Verificar búsqueda",
                            false
                        )
                    })
                    .catch(err => {
                        this.setState({ cargandoArticulos: false })
                        openNotification(
                            err?.response?.data?.cuerpo, 
                            err?.response?.data?.cuerpo, 
                            false
                        );
                    });
            })
        }
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal.
     */
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.esconderModal(false);

        this.setState({ 
            bloquearBotones: false, 
            arrPlazas: [], 
            arrDrives: [],
            arrArticulos: [],
            guardando: false,
            cargandoDrive: false,
            cargandoArticulos: false
        })
    }

    /**
     * Comportamiento al confirmar la asignación de la unidad de medida
     * @param: nada.
     * @return: nada.
     */
    showConfirm = (e) => {
       e.preventDefault();
       this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    title: 'Confirmar',
                    content: <div><b>¿Está seguro de editar la configuración?</b> Se cambiará la información actual de la configuración.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-asignacion-udm-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-asignacion-udm-form',
                    },
                    onOk: () => {
                        this.setState({ cargando: true, bloquearBotones: true }, this.editarAsignacionUDM())
                    },
                });
            }
        });
    }

    editarAsignacionUDM = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let state = { ...this.state }
                let id_articuloMultiplo = null;
                let objEnviar = {};

                console.log(values)
                
                objEnviar = {
                    sitio_id: values.drive,
                    articulo_id: values.articulo,
                    multiplo: values.multiplo
                }

                if(this.props.asignarUDM_selected !== undefined){
                    if (this.props.asignarUDM_selected !== null) {
                        id_articuloMultiplo = this.props.asignarUDM_selected.id;
                    }
                }

                this.setState({ cargando: true }, () => {
                    ArticulosMultiplosRequest.editarConfArticulosMult(id_articuloMultiplo, objEnviar)
                        .then(response => {
                            state.cargando = false;
                            state.bloquearBotones = false;
                            
                            this.props.esconderModal(true);
                            this.props.form.resetFields();
                        })
                        .catch(err => {
                            this.setState({ cargando: false, bloquearBotones: false });
                            openNotification(
                                err?.response?.data?.cuerpo,
                                err?.response?.data?.titulo,
                                false
                            );
                        });
                });
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <Modal
                    title= { this.props.modo === 'ver' ? 'Ver detalle configuración' : this.props.modo === 'editar' ? 'Editar configuración' : 'Nueva configuración'}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.showConfirm}
                    width={this.state.isPos ? "80%" : "70%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-asignarUDM"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo === 'ver' ? 'display-none' : ''}
                                key="submit"
                                id="boton-guardar-asignarUDM-form"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.guardando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                    >
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={12}>
                                    <Form.Item
                                        label={this.props.modo === 'ver' ? <b>Buscar artículo por Código / Descripción</b> : 'Buscar artículo por Código / Descripción'}
                                        colon={this.props.modo !== 'ver' ? true : false}
                                    >
                                        {getFieldDecorator('buscar_articulo', {
                                            rules: [
                                                { required: false },
                                                { whitespace: true, message: 'Por favor, ingrese Código / Descripción.' }
                                            ]
                                        })(
                                            <Search
                                                className={this.props.modo !== 'ver' ? 'btn-buscar-articulo-form' : 'disableInputText'}
                                                disabled={this.props.modo !== 'ver' ? false : true}
                                                id="input-search-articulo-asignacion-form"
                                                placeholder="Ingrese Código / Descripción"
                                                enterButton="Buscar"
                                                onSearch={value => { this.buscarArticulo(value) }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={ this.props.modo !== "ver" ? "Artículo" : <b>Artículo</b> }
                                        colon={ this.props.modo === 'ver' ? false : true }
                                    >
                                        {
                                            getFieldDecorator(
                                                'articulo', {
                                                    rules: [
                                                    {
                                                        required: this.props.modo === 'ver' ? false : true,
                                                        message: 'Por favor, seleccione un artículo.'
                                                    },
                                                    ],
                                                    initialValue: (
                                                        ( this.props.asignarUDM_selected !== undefined && this.props.asignarUDM_selected !== null ) 
                                                        ? this.props.asignarUDM_selected.articulo.id
                                                        : []
                                                    )
                                                }
                                            )
                                            (
                                                this.cargandoArticulos ? (
                                                    <Spin
                                                        tip="Cargando..."
                                                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                                                        spinning={this.state.cargandoArticulos}
                                                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                                                    >
                                                    </Spin>
                                                )
                                                : (
                                                    <Select
                                                        id="select-articulo-asignacion-unidad"
                                                        allowClear
                                                        style={{ width: "100%" }}
                                                        optionFilterProp="children"
                                                        placeholder="Seleccionar..."
                                                        defaultActiveFirstOption={false}
                                                        notFoundContent='No hay opciones'
                                                        disabled={(this.props.modo === 'ver' || !this.state.arrArticulos?.length) ? true : false }
                                                        showArrow={ this.props.modo === 'ver' ? false : true }
                                                        className={ this.props.modo === 'ver' ? 'disableInput' : '' }
                                                    >
                                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                                        {
                                                            this.state.arrArticulos.length > 0 &&
                                                            this.state.arrArticulos.map(obj => {
                                                                return (
                                                                    <Option
                                                                        key={obj.id}
                                                                        value={obj.id}>
                                                                        {obj.descripcion}
                                                                    </Option>
                                                                )
                                                            })
                                                        }
                                                    </Select> 
                                                )
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={12}>
                                <Col span={12}>
                                    <Form.Item
                                        label={ this.props.modo !== "ver" ? "Plaza" : <b>Plaza</b> }
                                        colon={ this.props.modo === 'ver' ? false : true }
                                    >
                                        {
                                            getFieldDecorator(
                                                'plaza', {
                                                    rules: [
                                                    {
                                                        required: this.props.modo === 'ver' ? false : true,
                                                        message: 'Por favor, seleccione una plaza.'
                                                    },
                                                    ],
                                                    initialValue: (
                                                        ( this.props.asignarUDM_selected !== undefined && this.props.asignarUDM_selected !== null ) 
                                                        ? this.props.asignarUDM_selected.sitio.plaza
                                                        : []
                                                    )
                                                }
                                            )
                                            (
                                                <Select
                                                    id="select-plaza-asignacion-unidad"
                                                    showSearch
                                                    allowClear
                                                    style={{ width: "100%" }}
                                                    optionFilterProp="children"
                                                    placeholder="Seleccionar..."
                                                    defaultActiveFirstOption={false}
                                                    notFoundContent='No hay opciones'
                                                    onChange={this.onChangePlaza}
                                                    disabled={ this.props.modo === 'ver' ? true : false }
                                                    showArrow={ this.props.modo === 'ver' ? false : true }
                                                    className={ this.props.modo === 'ver' ? 'disableInput' : '' }
                                                >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                    {
                                                        this.state.arrPlazas.length > 0 &&
                                                        this.state.arrPlazas.map(obj => {
                                                            return (
                                                                <Option
                                                                    key={obj.id}
                                                                    value={obj.id}>
                                                                    {obj.nombre}
                                                                </Option>
                                                            )
                                                        })
                                                    }
                                                </Select> 
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Drive" : <b>Drive</b>}
                                        colon={this.props.modo === 'ver' ? false : true}
                                    >
                                        {
                                            getFieldDecorator('drive', {
                                                rules: [
                                                    {
                                                        required: this.props.modo === 'ver' ? false : true,
                                                        message: 'Por favor, seleccione un drive.'
                                                    },
                                                ],
                                                initialValue: (
                                                    ( this.props.asignarUDM_selected !== undefined && this.props.asignarUDM_selected !== null ) 
                                                    ? this.props.asignarUDM_selected.sitio.id
                                                    : []
                                                )
                                            })
                                            (
                                                this.state.cargandoDrive ? (
                                                    <Spin
                                                        tip="Cargando..."
                                                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                                                        spinning={this.state.cargandoDrive}
                                                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                                                    >
                                                    </Spin>
                                                )
                                                :(
                                                    <Select
                                                        id="select-drive-asignacion-unidad"
                                                        showSearch
                                                        style={{ width: "100%" }}
                                                        defaultActiveFirstOption={false}
                                                        notFoundContent='No hay opciones'
                                                        placeholder="Seleccionar..."
                                                        optionFilterProp="children"
                                                        allowClear
                                                        showArrow={this.props.modo === 'ver' ? false : true}
                                                        disabled={(this.props.modo === 'ver' || !this.state.arrDrives?.length) ? true : false}
                                                        className={this.props.modo === 'ver' ? 'disableInput' : ''}
                                                    >
                                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                                        {
                                                            this.state.arrDrives.length > 0 &&
                                                            this.state.arrDrives.map(obj => {
                                                                return (
                                                                    <Option
                                                                        key={obj.id}
                                                                        value={obj.id}>
                                                                        {obj.nombre}
                                                                    </Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                )
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={12}>
                                <Col span={12}>
                                    <Form.Item
                                        label={ this.props.modo !== "ver" ? "Múltiplo" : <b>Múltiplo</b> }
                                        colon={(this.props.modo !== "ver" ? true : false)}
                                    >
                                        {   getFieldDecorator(
                                                'multiplo', {
                                                    rules: [
                                                        { required: this.props.modo !== "ver" ? true : false, message: 'Por favor, ingrese el múltiplo.' },
                                                    ],
                                                    initialValue: (
                                                        (this.props.asignarUDM_selected !== undefined && this.props.asignarUDM_selected !== null) ? this.props.asignarUDM_selected.multiplos_pedidos : null
                                                    )
                                                }
                                            )
                                            (<InputNumber
                                                style={{ width: "100%" }}
                                                id="input-multiplo-form-asignar-unidad"
                                                type="number"
                                                placeholder='Ingrese múltiplo'
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={5}
                                                max={10000}
                                                precision={0}
                                            />)
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div>
        );
    }
}
export default Form.create()(FormAsignarUnidad);

